export const products = [
  {
    id: 1,
    name: "Peppermint + Rosemary",
    description: "Headache relief • Increases clarity • Helps focus",
    benefits: [
      "Relieves headaches naturally",
      "Enhances mental clarity",
      "Improves concentration and focus",
      "Energizing aroma"
    ],
    price: 299,
    image: "https://customer-assets.emergentagent.com/job_upcycled-wellness/artifacts/hkg864tq_IMG_4413.heic",
    icon: "🍃",
    category: "wellness"
  },
  {
    id: 2,
    name: "Eucalyptus",
    description: "Decongestant • Breath-easy aroma",
    benefits: [
      "Natural decongestant",
      "Eases breathing",
      "Refreshing scent",
      "Cold and congestion relief"
    ],
    price: 299,
    image: "https://customer-assets.emergentagent.com/job_upcycled-wellness/artifacts/fe0ls09k_IMG_4412.heic",
    icon: "🌿",
    category: "wellness"
  },
  {
    id: 3,
    name: "Citronella",
    description: "Mosquito repellant • Perfect for travel & camping",
    benefits: [
      "Natural insect repellent",
      "Ideal for outdoor activities",
      "Travel-friendly",
      "Long-lasting protection"
    ],
    price: 299,
    image: "https://customer-assets.emergentagent.com/job_upcycled-wellness/artifacts/169o8u0k_IMG_4422.heic",
    icon: "🦟",
    category: "outdoor"
  },
  {
    id: 4,
    name: "Bergamot",
    description: "Stress relief • Anxiety calming",
    benefits: [
      "Reduces stress and tension",
      "Calms anxiety",
      "Promotes relaxation",
      "Uplifting citrus scent"
    ],
    price: 299,
    image: "https://customer-assets.emergentagent.com/job_upcycled-wellness/artifacts/itk67x9u_IMG_4423.heic",
    icon: "🧘",
    category: "wellness"
  },
  {
    id: 5,
    name: "Christmas Scent",
    description: "Holiday warmth • Pine + cinnamon",
    benefits: [
      "Festive holiday aroma",
      "Warm and cozy scent",
      "Perfect for celebrations",
      "Creates holiday atmosphere"
    ],
    price: 299,
    image: "https://customer-assets.emergentagent.com/job_upcycled-wellness/artifacts/dda9so0k_IMG_4437.heic",
    icon: "🎄",
    category: "seasonal"
  }
];

export const pricingPackages = [
  {
    id: 'single',
    name: 'Single Pouch',
    price: 299,
    quantity: 1,
    savings: 0,
    popular: false
  },
  {
    id: 'duo',
    name: 'Duo Pack',
    price: 499,
    quantity: 2,
    savings: 99,
    popular: true
  },
  {
    id: 'quad',
    name: 'Wellness Bundle',
    price: 999,
    quantity: 4,
    savings: 197,
    popular: false
  }
];

export const uses = [
  {
    id: 1,
    title: "Car Fresheners",
    description: "Keep your car smelling fresh and inviting with natural essential oils",
    icon: "🚗",
    image: "https://customer-assets.emergentagent.com/job_upcycled-wellness/artifacts/dda9so0k_IMG_4437.heic"
  },
  {
    id: 2,
    title: "Closet Fresheners",
    description: "Naturally freshen your wardrobe while keeping insects away",
    icon: "👔",
    image: "https://customer-assets.emergentagent.com/job_upcycled-wellness/artifacts/169o8u0k_IMG_4422.heic"
  },
  {
    id: 3,
    title: "Kids School Bags",
    description: "Add a pleasant aroma to backpacks and gym bags",
    icon: "🎒",
    image: "https://customer-assets.emergentagent.com/job_upcycled-wellness/artifacts/itk67x9u_IMG_4423.heic"
  },
  {
    id: 4,
    title: "Meditation Corners",
    description: "Create a calming atmosphere for your mindfulness practice",
    icon: "🧘‍♀️",
    image: "https://customer-assets.emergentagent.com/job_upcycled-wellness/artifacts/hkg864tq_IMG_4413.heic"
  }
];

export const sustainabilityPoints = [
  {
    icon: "♻️",
    title: "Upcycled Fabrics",
    description: "Made from leftover factory fabric, reducing waste"
  },
  {
    icon: "🌱",
    title: "Natural Oils",
    description: "Infused with pure essential oils for authentic aromatherapy"
  },
  {
    icon: "🎁",
    title: "Gift-Ready",
    description: "Beautifully packaged with eco-friendly materials"
  },
  {
    icon: "🌍",
    title: "Zero Waste Initiative",
    description: "Every piece contributes to our mission of sustainability"
  },
  {
    icon: "🇮🇳",
    title: "Handmade in India",
    description: "Crafted with care by skilled artisans"
  },
  {
    icon: "🌿",
    title: "Long-lasting Aroma",
    description: "Quality essential oils ensure enduring fragrance"
  }
];